

const __request = require(`@/lib/data-service/default/__request/__request_contentType_json`);

// 供应商确认合同（确认无误）接口地址： http://192.168.0.9:8080/doc.html#/yinzhilv_travel/es-ign-platform-controller/supplierAffirmFileUsingPOST
export default function web_esIgn_esIgnPlatformController_supplierAffirmFile(pParameter) {
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/esIgn/esIgnPlatformController/supplierAffirmFile';
  params.data = pParameter;

  return new Promise(function(resolve, reject) {
    resolve(__request(params))
  })
}
